// assets
import {
  TeamOutlined,
  ToolOutlined,
  WarningOutlined,
  BookOutlined,
  FileTextOutlined,
  AuditOutlined,
  UserOutlined,
  FileProtectOutlined,
  SolutionOutlined,
} from '@ant-design/icons';

// icons
const icons = {
  TeamOutlined,
  ToolOutlined,
  WarningOutlined,
  BookOutlined,
  FileTextOutlined,
  AuditOutlined,
  UserOutlined,
  FileProtectOutlined,
  SolutionOutlined,
};

// ==============================|| MENU ITEMS - MANAGEMENT ||============================== //

const management = {
  id: 'management',
  title: 'Gestão',
  type: 'group',
  children: [
    {
      id: 'clientes',
      title: 'Clientes',
      type: 'item',
      url: '/clientes',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'equipamentos',
      title: 'Equipamentos',
      type: 'item',
      url: '/equipamentos',
      icon: icons.ToolOutlined,
      breadcrumbs: false
    },
    {
      id: 'perigos',
      title: 'Perigos',
      type: 'item',
      url: '/perigos',
      icon: icons.WarningOutlined,
      breadcrumbs: false
    },
    // {
    //   id: 'laudos',
    //   title: 'Laudos ART',
    //   type: 'item',
    //   url: '/laudos',
    //   icon: icons.FileTextOutlined,
    //   breadcrumbs: false
    // },
    {
      id: 'art',
      title: 'ART',
      type: 'item',
      url: '/art',
      icon: icons.AuditOutlined,
      breadcrumbs: false
    },
    {
      id: 'propostas',
      title: 'Propostas Comerciais',
      type: 'item',
      url: '/propostas',
      icon: icons.FileProtectOutlined,
      breadcrumbs: false
    },
    {
      id: 'servicos',
      title: 'Serviços',
      type: 'item',
      url: '/servicos',
      icon: icons.SolutionOutlined,
      breadcrumbs: false
    },
  ]
};

export default management;
